import { LineStyle, PolygonPlaneMeshProps } from '@editor/interfaces/canvas'

export const DEFAULT_PLANES_STYLES: Partial<PolygonPlaneMeshProps> = {
  transparent: true,
  color: 'white',
  opacity: 1,
  guideLine: {
    visible: false,
    style: LineStyle.Solid,
    color: 'yellow',
    thickness: 0.0075,
    renderOrder: 999,
  },
}

export const HOVERED_PLANE_STYLES: Partial<PolygonPlaneMeshProps> = {
  ...DEFAULT_PLANES_STYLES,
  label: {
    visible: true,
    backgroundColor: '#FFFF00',
  },
  guideLine: {
    ...DEFAULT_PLANES_STYLES.guideLine,
    color: '#FFFF00',
    visible: true,
  },
  guideLabel: {
    backgroundColor: '#FFFF00',
    color: '#333',
  },
}

export const SELECTED_PLANE_STYLES: Partial<PolygonPlaneMeshProps> = {
  ...DEFAULT_PLANES_STYLES,
  label: {
    backgroundColor: 'yellow',
  },
  guideLine: {
    ...HOVERED_PLANE_STYLES.guideLine,
    color: 'white',
  },
  guideLabel: {},
}
